export const borders = {
  none: 0,
  hairline: '1px solid',
  thin: '2px solid',
  heavy: '4px solid'
};
